import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileSpreadsheet = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M13 3.5V7a2 2 0 0 0 2 2h3.5m-10 8.5V16m3.5 1.5V13m3.5 4.5V15M7 3h5.172a2 2 0 0 1 1.414.586l4.828 4.828A2 2 0 0 1 19 9.828V19a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M6.75 2H12v5.25A2.75 2.75 0 0 0 14.75 10H20v9.25A2.75 2.75 0 0 1 17.25 22H6.75A2.75 2.75 0 0 1 4 19.25V4.75A2.75 2.75 0 0 1 6.75 2m2.5 14.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0zM12 13a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 13m4.25 2.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0z'
          fill='currentColor'
        />
        <path
          d='m19.487 8.427.07.073H14.75c-.69 0-1.25-.56-1.25-1.25V2.443q.038.034.073.07z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
